// tslint:disable:max-line-length
// tslint:disable:whitespace

/************************************************************************************/
/* WARNING: This file is generated automatically. Don't edit it by hand             */
/************************************************************************************/

/** Flags that determine the method for determining the norm in re-wire-ing */
export const REWIRE_PARALLEL_NORM_LOGIC: Record<string, RewireParallelNormLogicEnum> = {
    /** Pick normative of the principal child */
    first: "first",
    /** Sum normatives */
    sum: "sum"
};
export type RewireParallelNormLogicEnum =
    "first" |
    "sum";

/** Status of production as reported by the MES system */
export const PRODUCTION_STATUSES: Record<string, ProductionStatusesEnum> = {
    /** This production is confirmed */
    confirmed: "confirmed",
    /** This production should be deleted */
    deleted: "deleted",
    /** This production is not confirmed */
    unconfirmed: "unconfirmed"
};
export type ProductionStatusesEnum =
    "confirmed" |
    "deleted" |
    "unconfirmed";

/** Used in API to define if we care about input, produced or both materials */
export const STOCK_DIRECTION: Record<string, StockDirectionEnum> = {
    in: "in",
    in_and_out: "in_and_out",
    out: "out"
};
export type StockDirectionEnum =
    "in" |
    "in_and_out" |
    "out";

/** Types of stock-requirements */
export const STOCK_REQUIREMENTS_TYPES: Record<string, StockRequirementsTypesEnum> = {
    received: "received",
    required: "required"
};
export type StockRequirementsTypesEnum =
    "received" |
    "required";

/** MES Types */
export const MES: Record<string, MesEnum> = {
    proses: "proses",
    sinapro: "sinapro"
};
export type MesEnum =
    "proses" |
    "sinapro";

/** General classification of downtime types. Real downtime time, reported by the MES system, should be mapped into one of these categories. */
export const DOWNTIME_TYPES: Record<string, DowntimeTypesEnum> = {
    holidays: "holidays",
    machine_maintenance: "machine_maintenance",
    mechanical_failure: "mechanical_failure",
    no_material: "no_material",
    no_work: "no_work",
    no_worker: "no_worker",
    other: "other",
    planned_stop: "planned_stop",
    power_failure: "power_failure",
    self_maintenance: "self_maintenance",
    setup_during_process: "setup_during_process",
    setup_of_machine: "setup_of_machine",
    tool_failure: "tool_failure",
    tool_setup: "tool_setup"
};
export type DowntimeTypesEnum =
    "holidays" |
    "machine_maintenance" |
    "mechanical_failure" |
    "no_material" |
    "no_work" |
    "no_worker" |
    "other" |
    "planned_stop" |
    "power_failure" |
    "self_maintenance" |
    "setup_during_process" |
    "setup_of_machine" |
    "tool_failure" |
    "tool_setup";

/** Different levels of insight priorities */
export const INSIGHT_PRIORITIES: Record<string, InsightPrioritiesEnum> = {
    high: "high",
    low: "low",
    medium: "medium",
    none: "none"
};
export type InsightPrioritiesEnum =
    "high" |
    "low" |
    "medium" |
    "none";

/** Different types of manufacturing orders */
export const ORDER_TYPE: Record<string, OrderTypeEnum> = {
    chunk: "chunk",
    full: "full",
    parallel: "parallel",
    plan: "plan"
};
export type OrderTypeEnum =
    "chunk" |
    "full" |
    "parallel" |
    "plan";

/** Different statuses of manufacturing orders */
export const ORDER_STATUS: Record<string, OrderStatusEnum> = {
    closed: "closed",
    closed_overflow: "closed_overflow",
    closed_underflow: "closed_underflow",
    open: "open"
};
export type OrderStatusEnum =
    "closed" |
    "closed_overflow" |
    "closed_underflow" |
    "open";

/** Different possible sources of how manufacturing orders are generated */
export const ORDER_GENERATED_BY: Record<string, OrderGeneratedByEnum> = {
    batch_operations: "batch_operations",
    manual_entry_subcontractor: "manual_entry_subcontractor",
    parallel_materials: "parallel_materials",
    planning_board_split: "planning_board_split",
    sap: "sap",
    sap_subcontracted_materials: "sap_subcontracted_materials"
};
export type OrderGeneratedByEnum =
    "batch_operations" |
    "manual_entry_subcontractor" |
    "parallel_materials" |
    "planning_board_split" |
    "sap" |
    "sap_subcontracted_materials";

/** Flag how Sundays last shift should be handled */
export const WORK_SCHEDULE_SUNDAY_LOGIC: Record<string, WorkScheduleSundayLogicEnum> = {
    nop: "nop",
    swap: "swap"
};
export type WorkScheduleSundayLogicEnum =
    "nop" |
    "swap";

/** How is stock triggering ... ?  */
export const STOCK_TRIGGERING_OUTSTANDING: Record<string, StockTriggeringOutstandingEnum> = {
    current_stock: "current_stock",
    nop: "nop",
    produced_minus_consumed: "produced_minus_consumed"
};
export type StockTriggeringOutstandingEnum =
    "current_stock" |
    "nop" |
    "produced_minus_consumed";

/** How is stock triggering ... ?  */
export const STOCK_TRIGGERING_DELAY_SOURCE: Record<string, StockTriggeringDelaySourceEnum> = {
    fixed_plus_norm_machine_time: "fixed_plus_norm_machine_time",
    norm_machine_time: "norm_machine_time",
    norm_tool_setup_time: "norm_tool_setup_time",
    time_end_time_start: "time_end_time_start"
};
export type StockTriggeringDelaySourceEnum =
    "fixed_plus_norm_machine_time" |
    "norm_machine_time" |
    "norm_tool_setup_time" |
    "time_end_time_start";

/** How is stock triggering ... ?  */
export const STOCK_TRIGGERING_TYPE: Record<string, StockTriggeringTypeEnum> = {
    ageing: "ageing",
    atp_ageing: "atp_ageing",
    subcontracting: "subcontracting"
};
export type StockTriggeringTypeEnum =
    "ageing" |
    "atp_ageing" |
    "subcontracting";

/** Possible types of resources that can be included into planning */
export const PLANNING_RESOURCE_TYPES: Record<string, PlanningResourceTypesEnum> = {
    line: "line",
    person: "person"
};
export type PlanningResourceTypesEnum =
    "line" |
    "person";

/** How planning handles material tracking */
export const PLANNING_MATERIAL_TRACKING: Record<string, PlanningMaterialTrackingEnum> = {
    exact: "exact",
    order: "order"
};
export type PlanningMaterialTrackingEnum =
    "exact" |
    "order";

/** Scheduling strategy */
export const PLANNING_SCHEDULE_STRATEGY: Record<string, PlanningScheduleStrategyEnum> = {
    /** Beam search for best scheduling of operations. */
    BFS: "BFS",
    /** Backward planning. */
    backward_planning: "backward_planning",
    /** Keep same resource and order of orders, but take into account constraints to determine time */
    rectify: "rectify",
    /** Sequencing planning. */
    sequencing_planning: "sequencing_planning"
};
export type PlanningScheduleStrategyEnum =
    "BFS" |
    "backward_planning" |
    "rectify" |
    "sequencing_planning";

/** People scheduling strategy */
export const PEOPLE_SCHEDULING_STRATEGY: Record<string, PeopleSchedulingStrategyEnum> = {
    /** Default scheduling strategy */
    default: "default",
    /** Schedule less experienced people first (lower score first) */
    less_experienced_first: "less_experienced_first",
    /** Schedule more experienced people first (higher score first) */
    more_experienced_first: "more_experienced_first"
};
export type PeopleSchedulingStrategyEnum =
    "default" |
    "less_experienced_first" |
    "more_experienced_first";

/** How is search time range matched to insight time range */
export const INSIGHT_RANGE_SEARCH_TYPE: Record<string, InsightRangeSearchTypeEnum> = {
    /** from <= insight.ts_to <= to */
    ends_in: "ends_in",
    /** insights.ts <= from <= to <=insights.ts_to */
    includes_range: "includes_range",
    /** intersect([from,to], [insights.ts,insights.ts_to]) is non-zero */
    overlaps_with_range: "overlaps_with_range",
    /** from <= insight.ts <= to */
    starts_in: "starts_in"
};
export type InsightRangeSearchTypeEnum =
    "ends_in" |
    "includes_range" |
    "overlaps_with_range" |
    "starts_in";

/** Type of constraint */
export const PLANNING_CONSTRAINT_TYPE: Record<string, PlanningConstraintTypeEnum> = {
    /** Not predefined, by only available for the operation so must be included */
    adhoc: "adhoc",
    /** Currently selected for the order but not same as any of the available production versions. */
    current: "current",
    /** Defined by production version or selected in matrix for the line group */
    production_version: "production_version"
};
export type PlanningConstraintTypeEnum =
    "adhoc" |
    "current" |
    "production_version";

/** Types of explanations informing why an operation was or was not scheduled */
export const PLANNING_EXPLANATION_TYPE: Record<string, PlanningExplanationTypeEnum> = {
    /** operation was already fixed in the input */
    frozen: "frozen",
    /** missing input material for the operation */
    missing_input_material: "missing_input_material",
    /** so far no automatic planning was ran on the planning board */
    no_automatic_planning: "no_automatic_planning",
    /** no resource available to schedule the operation */
    no_resource_available: "no_resource_available",
    /** operation was not part of automatic planning process */
    not_planned: "not_planned",
    /** search did not reach this operation */
    not_reached: "not_reached",
    /** previous operation not scheduled */
    previous_operation_not_scheduled: "previous_operation_not_scheduled",
    /** we found a slot and input materials for the operation */
    scheduled: "scheduled"
};
export type PlanningExplanationTypeEnum =
    "frozen" |
    "missing_input_material" |
    "no_automatic_planning" |
    "no_resource_available" |
    "not_planned" |
    "not_reached" |
    "previous_operation_not_scheduled" |
    "scheduled";

/** Warnings created as part of scheduling process */
export const PLANNING_WARNING_TYPE: Record<string, PlanningWarningTypeEnum> = {
    /** operation was frozen but logic for placing it on predefined place failed */
    frozen: "frozen",
    /** no warning */
    none: "none",
    /** available production versions for scheduling the operations do not match matrix constraints */
    prod_ver_mismatch: "prod_ver_mismatch",
    /** rectify logic could not place operation on the schedule */
    rectify_unscheduled: "rectify_unscheduled"
};
export type PlanningWarningTypeEnum =
    "frozen" |
    "none" |
    "prod_ver_mismatch" |
    "rectify_unscheduled";

/** Type of plan import */
export const PLAN_IMPORT_TYPE: Record<string, PlanImportTypeEnum> = {
    /** Explicit lists of planned order ids and order ids */
    lists: "lists",
    /** All planned and work orders for a given material list */
    material: "material",
    /** All planned and work orders for a given plant */
    plant: "plant",
    /** All planned and work orders for a given workplace list */
    workplace: "workplace"
};
export type PlanImportTypeEnum =
    "lists" |
    "material" |
    "plant" |
    "workplace";

/** Type of model used to describe material-process-resource */
export const PLANNING_MODEL_ITEM_TYPE: Record<string, PlanningModelItemTypeEnum> = {
    /** Production function is approximated with step function */
    batch: "batch",
    /** Production function is approximated with linear function */
    continuous: "continuous"
};
export type PlanningModelItemTypeEnum =
    "batch" |
    "continuous";

/** Values stored in local storage on GUI */
export const GUI_LOCAL_STORAGE: Record<string, GuiLocalStorageEnum> = {
    /** In DEV env keep same hash for quick sim on the planning board to speedup loading */
    fixed_quick_sim_cache_hash: "fixed_quick_sim_cache_hash"
};
export type GuiLocalStorageEnum =
    "fixed_quick_sim_cache_hash";

/** Cache hash values for quick simulationm when in dev fixed moded */
export const QUICK_SIM_FIXED_CACHE_HASH: Record<string, QuickSimFixedCacheHashEnum> = {
    hopsasa: "hopsasa",
    tralala: "tralala"
};
export type QuickSimFixedCacheHashEnum =
    "hopsasa" |
    "tralala";

/** Indicates on which level KPIs where computed */
export const KPI_LEVEL: Record<string, KpiLevelEnum> = {
    line: "line",
    line_group: "line_group",
    plant: "plant"
};
export type KpiLevelEnum =
    "line" |
    "line_group" |
    "plant";

/** Extra entity types */
export const EXTRA_ENTITY_DATASOURCE_TYPE: Record<string, ExtraEntityDatasourceTypeEnum> = {
    orders: "orders",
    stock_requirements: "stock_requirements"
};
export type ExtraEntityDatasourceTypeEnum =
    "orders" |
    "stock_requirements";

/** Different categories of calendar events */
export const CALENDAR_EVENT_CATEGORY: Record<string, CalendarEventCategoryEnum> = {
    holiday: "holiday"
};
export type CalendarEventCategoryEnum =
    "holiday";

/** Extra entity data types */
export const EXTRA_ENTITY_DATA_TYPE: Record<string, ExtraEntityDataTypeEnum> = {
    comment: "comment",
    custom_field: "custom_field"
};
export type ExtraEntityDataTypeEnum =
    "comment" |
    "custom_field";

/** Standard KPI that can be reported by the integration tasks */
export const INTEGRATION_TASK_KPI: Record<string, IntegrationTaskKpiEnum> = {
    downtime_records_final: "downtime_records_final",
    downtime_records_initial: "downtime_records_initial",
    downtime_records_intermediate: "downtime_records_intermediate",
    material_records_final: "material_records_final",
    material_records_initial: "material_records_initial",
    plan_bom_import_records_final: "plan_bom_import_records_final",
    plan_bom_import_records_initial: "plan_bom_import_records_initial",
    plan_bom_import_records_intermediate: "plan_bom_import_records_intermediate",
    plan_import_records_final: "plan_import_records_final",
    plan_import_records_initial: "plan_import_records_initial",
    plan_import_records_intermediate: "plan_import_records_intermediate",
    production_records_final: "production_records_final",
    production_records_initial: "production_records_initial",
    production_records_intermediate: "production_records_intermediate",
    stock_records_final: "stock_records_final",
    stock_records_initial: "stock_records_initial",
    stock_records_intermediate: "stock_records_intermediate",
    stock_requirements_records_final: "stock_requirements_records_final",
    stock_requirements_records_initial: "stock_requirements_records_initial",
    stock_requirements_records_intermediate: "stock_requirements_records_intermediate"
};
export type IntegrationTaskKpiEnum =
    "downtime_records_final" |
    "downtime_records_initial" |
    "downtime_records_intermediate" |
    "material_records_final" |
    "material_records_initial" |
    "plan_bom_import_records_final" |
    "plan_bom_import_records_initial" |
    "plan_bom_import_records_intermediate" |
    "plan_import_records_final" |
    "plan_import_records_initial" |
    "plan_import_records_intermediate" |
    "production_records_final" |
    "production_records_initial" |
    "production_records_intermediate" |
    "stock_records_final" |
    "stock_records_initial" |
    "stock_records_intermediate" |
    "stock_requirements_records_final" |
    "stock_requirements_records_initial" |
    "stock_requirements_records_intermediate";

/** Value to use with PostgreSQL fields to avoid NULL check failing */
export const UNKNOWN_CONST: Record<string, UnknownConstEnum> = {
    unknown: "unknown"
};
export type UnknownConstEnum =
    "unknown";

/** Status of shift exchange listing */
export const SHIFT_EXCHANGE_LISTING_STATUS: Record<string, ShiftExchangeListingStatusEnum> = {
    available: "available",
    cancelled: "cancelled",
    confirmed: "confirmed"
};
export type ShiftExchangeListingStatusEnum =
    "available" |
    "cancelled" |
    "confirmed";

/** Status of shift exchange request */
export const SHIFT_EXCHANGE_REQUEST_STATUS: Record<string, ShiftExchangeRequestStatusEnum> = {
    confirmed: "confirmed",
    pending: "pending",
    rejected: "rejected"
};
export type ShiftExchangeRequestStatusEnum =
    "confirmed" |
    "pending" |
    "rejected";
